<template>
    <div class="d-flex align-items-center search-result-item ul-wide-border-panel mt-2 mb-2 p-1">
        <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 mfr-ref-des-wrapper">
            <img class="mfr-ref-des-thumbnail" v-bind:src="searchItem.imageUrl">
            <a class="mfr-ref-des-thumbnail-credit" target="_blank" rel="nofollow" v-bind:href="searchItem.imageCreditURL">{{searchItem.imageCreditName}}</a>
        </div>

        <div class="d-flex flex-column justify-content-center pl-2 pr-2 flex-grow-1">
            <div class="font-size-14">{{searchItem.manufacturer}}</div>
            <span class="font-size-14">{{searchItem.partNumber}}</span>
            <div class="font-size-10">{{searchItem.description}}</div>
        </div>
        <div class="pr-3" v-show="loggedIn">
            <a class="btn btn-dark btn-sm" v-on:click.prevent="dowload(searchItem.uniqueId)">Download</a>
        </div>
        <div class="pr-3" v-show="loggedIn == false">
            <a class="btn btn-dark btn-sm" href="#" v-on:click.prevent="signIn">Sign In to Download</a>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'ReferenceSearchItem',
        props: {
            searchItem: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            dowload: function (uniqueId) {
                this.$store.dispatch('gtmReferenceDownload', { mfrName: this.searchItem.manufacturer, mfrPN: this.searchItem.partNumber, cadProduct: 'Eagle'})
                this.$store.dispatch('downloadReference', uniqueId);
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            loggedIn: function () {
                return this.oidcIsAuthenticated
            },
        }
    }
</script>

<style scoped>
    .mfr-ref-des-thumbnail {
        max-height: 50px;
        max-width: 75px;
    }

    .mfr-ref-des-thumbnail-credit {
        font-size: 8px;
        text-align: center;
    }

    .btn-sm{
        max-width: 97px;
    }
</style>		